import { RuleSeverity } from './ValidationState';
import { Utils } from '../Utils';
import { Settings } from '../Settings';
var ValidationDisplayInfo = /** @class */ (function () {
    function ValidationDisplayInfo() {
        this.additionalClassName = "";
        this.errorText = "";
        this.asyncBusyText = "";
        this.warningText = "";
        this.infoText = "";
        this.severity = RuleSeverity.None;
        this.variant = "light";
    }
    Object.defineProperty(ValidationDisplayInfo.prototype, "displayText", {
        get: function () {
            switch (this.severity) {
                case RuleSeverity.Error: return this.errorText;
                case RuleSeverity.AsyncBusy: return this.asyncBusyText;
                case RuleSeverity.Warning: return this.warningText;
                case RuleSeverity.Info: return this.infoText;
            }
            return "";
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ValidationDisplayInfo.prototype, "editorClassName", {
        get: function () {
            if (this.severity != RuleSeverity.None) {
                return "is-invalid " + this.additionalClassName;
            }
            return "";
        },
        enumerable: false,
        configurable: true
    });
    ValidationDisplayInfo.prototype.applyToDom = function (elementProps, addTooltip) {
        if (this.severity) {
            elementProps.className = Utils.joinWithSpaces(elementProps.className, this.editorClassName);
            if (addTooltip) {
                elementProps["data-tip"] = this.displayText;
                elementProps["data-tip-class"] = this.additionalClassName;
            }
        }
    };
    return ValidationDisplayInfo;
}());
export { ValidationDisplayInfo };
var ValidationDisplayHelper = /** @class */ (function () {
    function ValidationDisplayHelper() {
    }
    ValidationDisplayHelper.getDisplayInfo = function (ruleState, canDisplayAll) {
        var displayInfo = new ValidationDisplayInfo();
        displayInfo.severity = canDisplayAll ? ruleState.severity : ruleState.forceDisplaySeverity;
        if (displayInfo.severity != RuleSeverity.None) {
            var allRules = ruleState.brokenRules;
            if (allRules === undefined) {
                allRules = [ruleState];
            }
            allRules.forEach(function (rule) {
                if (displayInfo.severity == RuleSeverity.Info)
                    displayInfo.infoText = ValidationDisplayHelper.join(displayInfo.infoText, rule.messages);
                if (displayInfo.severity == RuleSeverity.Warning)
                    displayInfo.warningText = ValidationDisplayHelper.join(displayInfo.warningText, rule.warnings);
                if (displayInfo.severity == RuleSeverity.Error)
                    displayInfo.errorText = ValidationDisplayHelper.join(displayInfo.errorText, rule.errors);
                if (displayInfo.severity == RuleSeverity.AsyncBusy && rule.asyncBusyText) {
                    displayInfo.asyncBusyText = ValidationDisplayHelper.join(displayInfo.asyncBusyText, [rule.asyncBusyText]);
                }
            });
            switch (displayInfo.severity) {
                case RuleSeverity.Error:
                    displayInfo.additionalClassName = "error";
                    displayInfo.icon = Settings.icons.errorIcon;
                    displayInfo.variant = "danger";
                    break;
                case RuleSeverity.AsyncBusy:
                    displayInfo.additionalClassName = "busy";
                    displayInfo.icon = Settings.icons.loadingIcon;
                    displayInfo.variant = "info";
                    break;
                case RuleSeverity.Warning:
                    displayInfo.additionalClassName = "warning";
                    displayInfo.icon = Settings.icons.warningIcon;
                    displayInfo.variant = "warning";
                    break;
                case RuleSeverity.Info:
                    displayInfo.additionalClassName = "info";
                    displayInfo.icon = Settings.icons.infoIcon;
                    displayInfo.variant = "info";
                    break;
            }
        }
        return displayInfo;
    };
    ValidationDisplayHelper.join = function (initialString, list) {
        for (var i = 0; i < list.length; i++) {
            initialString += (initialString == "" ? "" : initialString.endsWith(".") ? " " : ". ") + list[i];
        }
        return initialString;
    };
    return ValidationDisplayHelper;
}());
export default ValidationDisplayHelper;
